import { Grid, styled } from "@mui/material";

const DialogGridButton = styled(Grid)(({ theme }) => ({
    margin: "1rem",
    textAlign: "center",
    marginTop: "2rem",
}));

export default DialogGridButton